import { motion } from "motion/react";
import { useTranslation } from "react-i18next";

export const TypingText = ({ text }: { text: string }) => {
  const { i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const characters = Array.from(text);
  const sharedAnimation = {
    scale: [1, 1.1, 1],
    textShadow: [
      "0 0 0 var(--shadow-color)",
      "0 0 1px var(--shadow-color)",
      "0 0 0 var(--shadow-color)",
    ],
    opacity: [0.5, 1, 0.5],
  };
  const sharedTransition = {
    duration: 0.5,
    repeat: Infinity,
    repeatType: "loop" as const,
    ease: "easeInOut" as const,
    repeatDelay: 2,
  };

  return (
    <div
      dir={isRTL ? "rtl" : "ltr"}
      className={`font-sans font-bold [--shadow-color:var(--color-neutral-500)] dark:[--shadow-color:var(--color-neutral-100)] inline-flex ${
        isRTL ? "flex-row-reverse" : ""
      }`}
    >
      {isRTL ? (
        <motion.span
          className="inline-block"
          initial={{ scale: 1, opacity: 0.5 }}
          animate={sharedAnimation}
          transition={sharedTransition}
        >
          {text}
        </motion.span>
      ) : (
        characters.map((char, i) => (
          <motion.span
            key={i}
            className="inline-block"
            initial={{ scale: 1, opacity: 0.5 }}
            animate={sharedAnimation}
            transition={{
              ...sharedTransition,
              delay: i * 0.05,
            }}
          >
            {char === " " ? "\u00A0" : char}
          </motion.span>
        ))
      )}
    </div>
  );
};
